<template>
  <div class="wrapper">
    <p class="title">扫码识别二维码 提交开票抬头</p>
    <section>
      <div class="qrcode-wrp">
        <VueQrcode class="qrcode" :value="url" :options="{size:500}"></VueQrcode>
        <p class="company-name">{{ companyInfo.name }}</p>
      </div>
    </section>
    <div class="download-btn" @click="exportQrCode">
      下载企业开票码
    </div>
    <!-- <div class="footer">
      <div class="company-info">
        <p class="iconfont">&#xe614;</p>
        <p class="company-name">
          慧穗数字科技（上海）有限公司
        </p>
        <div class="scantip">扫描二维码，关注公众号</div>
      </div>
      <div class="qrcode-wrp">
        <img src="@assets/img/qrcode.jpeg" alt="">
      </div>
    </div> -->
    <van-popup class="operation-popup" v-model="qrCodeVisible" >
      <div @click="qrCodeVisible = false">
        <img :src="imgSrc"/>
        <p>请长按图片保存</p>
      </div>
    </van-popup>
    <QrCode :url="url" :name="companyInfo.name" class="qrcode-export" ref="qrcode-img"></QrCode>
  </div>
</template>

<script>
import VueQrcode from '@xkeshi/vue-qrcode'
import { aesDoEncrypt } from '@utils/basicUtil'
import QrCode from './QrCode'
import { Popup } from 'vant'
export default {
  components: {
    VueQrcode,
    QrCode,
    [Popup.name]: Popup
  },
  props: {},
  data () {
    return {
      qrCodeVisible: false,
      imgSrc: ''
    }
  },
  computed: {
    companyInfo () {
      return this.$store.state.user.company
    },
    url () {
      const info = this.$store.state.user.company
      const params = {
        companyId: info.id,
        companyName: info.name
      }
      const key = aesDoEncrypt(params)
      return `http://${window.location.host}/order/scan-invoice?key=${key}`
    }
  },
  watch: {},
  created () {
  },
  mounted () {
  },
  activated () {},
  updated () {},
  methods: {
    exportQrCode () {
      this.qrCodeVisible = true
      let base64 = this.$refs['qrcode-img'].$el.querySelector('#canvas').toDataURL('image/png')
      this.imgSrc = base64
    }
  }
}
</script>
<style lang="less" scoped src="./style.less"/>
